import styled from 'styled-components';

export const Transfer = styled.div`
  font-family: 'Roboto';

  path {
    filter: unset;
  }

  .values {
    p:nth-child(1) {
      color: #8c8c8c;
    }
    p:nth-child(2) {
      span {
        min-width: 208px;
      }
    }
    p:nth-child(3) {
      color: #292623;
      span {
        border-radius: 4px;
        background: #002f6c;
      }
    }

    p:nth-child(4) {
      color: #5a5a5a;
    }
    p:nth-child(5) {
      span {
        border-radius: 4px;
        background: #ff842f;
      }
    }
    p:nth-child(6) {
      color: #5a5a5a;
    }
    p:nth-child(7) {
      span {
        border-radius: 4px;
        background: #ffb580;
      }
    }
    p:nth-child(8) {
      color: #5a5a5a;
    }
    p:nth-child(9) {
      span {
        border-radius: 4px;
        background: #b30000;
      }
    }
    p:nth-child(10) {
      color: #5a5a5a;
    }
  }
`;
